<div>
  <form [formGroup]="formGroup" class="text-sm">
    <div class="mb-5" [ngClass]="formGroup.controls['email'].touched ? (formGroup.controls['email'].errors ? 'has-error' : 'has-success') : ''">
      <label for="email">Email</label>
      <input id="email" type="text" placeholder="Enter Email" class="form-input" formControlName="email" />
      <small class="text-danger" *ngIf="formGroup.controls['email'].errors && formGroup.controls['email'].touched">
        {{ "please_provide_email" | translate }}
      </small>
    </div>
    <div class="mb-5" [ngClass]="formGroup.controls['password'].touched ? (formGroup.controls['password'].errors ? 'has-error' : 'has-success') : ''">
      <label for="password">Password</label>
      <div class="relative">
        <input id="password" [type]="passwordVisible ? 'text' : 'password'" placeholder="Enter Password" class="form-input" formControlName="password" />
        <button type="button" class="absolute inset-y-0 right-0 flex items-start pr-3 pt-2 focus:outline-0" tabindex="-1" (click)="togglePasswordVisibility()">
          <icon-eye-closed *ngIf="!passwordVisible; else hideIcon" class="dark:text-white" />
          <ng-template #hideIcon>
            <icon-eye-open class="dark:text-white" />
          </ng-template>
        </button>
      </div>
      <div *ngIf="formGroup.controls['password'].invalid && (formGroup.controls['password'].dirty || formGroup.controls['password'].touched)">
        <small class="text-danger" *ngIf="formGroup.controls['password'].errors?.['required']">{{ "enter_valid_password" | translate }}</small>
        <small class="text-danger" *ngIf="formGroup.controls['password'].errors?.['invalidPassword']">{{ "password_must_be_at_least_6_characters" | translate }}</small>
      </div>
    </div>
    <div class="mb-5" [ngClass]="formGroup.controls['agencyName'].touched ? (formGroup.controls['agencyName'].errors ? 'has-error' : 'has-success') : ''">
      <label for="agencyName">Agency Name</label>
      <input id="agencyName" type="text" placeholder="Enter Agency Name" class="form-input" formControlName="agencyName" />
      <small class="text-danger" *ngIf="formGroup.controls['agencyName'].errors && formGroup.controls['agencyName'].touched">
        {{ "please_provide_agencyName" | translate }}
      </small>
    </div>
    <div class="mb-5" [ngClass]="formGroup.controls['phone'].touched ? (formGroup.controls['phone'].errors ? 'has-error' : 'has-success') : ''">
      <label for="phone">Phone</label>
      <input id="phone" type="text" placeholder="{{ 'phone_input' | translate }}" class="form-input" formControlName="phone" />
      <small class="text-danger" *ngIf="formGroup.controls['phone'].errors && formGroup.controls['phone'].touched">
        {{ "please_provide_phone" | translate }}
      </small>
    </div>

    <div class="mb-5" [ngClass]="formGroup.controls['tier'].touched ? (formGroup.controls['tier'].errors ? 'has-error' : 'has-success') : ''">
      <label for="tier">Select Tier</label>
      <ng-select
        [items]="options$ | async"
        placeholder="Select Tier"
        [searchable]="false"
        [clearable]="false"
        class="custom-multiselect"
        bindLabel="title"
        bindValue="id"
        labelForId="tier"
        [formControlName]="'tier'"
        appendTo="body"
      >
      </ng-select>
      <small class="text-danger" *ngIf="formGroup.controls['tier'].errors && formGroup.controls['tier'].touched">
        {{ "please_provide_phone" | translate }}
      </small>
    </div>

    <div class="mb-5" *ngIf="formGroup.controls['createWithInstance'].value">
      <label for="domainName" [ngClass]="formGroup.controls['domainName'].touched ? (formGroup.controls['domainName'].errors ? 'has-error' : 'has-success') : ''">Domain Name</label>
      <div class="flex">
        <div
          class="flex items-center justify-center border border-[#e0e6ed] bg-[#eee] px-3 font-semibold dark:border-[#17263c] dark:bg-[#1b2e4b] ltr:rounded-l-md ltr:border-r-0 rtl:rounded-r-md rtl:border-l-0"
        >
          https://
        </div>
        <input id="domainName" formControlName="domainName" type="text" placeholder="tourisagent" (blur)="validateDomain()" class="form-input ltr:rounded-none rtl:rounded-none" />
        <div
          class="flex items-center justify-center border border-[#e0e6ed] bg-[#eee] px-3 font-semibold dark:border-[#17263c] dark:bg-[#1b2e4b] ltr:rounded-r-md ltr:border-l-0 rtl:rounded-l-md rtl:border-r-0"
        >
          .turistagent.com
        </div>
      </div>
      <small class="text-danger" *ngIf="formGroup.controls['domainName'].errors && formGroup.controls['domainName'].touched">
        {{ "please_provide_domainName" | translate }}
      </small>
      <small class="text-danger" *ngIf="formGroup.get('domainName')?.errors?.['invalidDomainName'] && formGroup.get('domainName')?.touched"> Only letters and dashes are allowed. </small>
      <small class="text-danger" *ngIf="formGroup.get('domainName')?.errors?.['domainTaken'] && formGroup.get('domainName')?.touched"> This domain is already taken. </small>
    </div>

    <div class="mt-8 flex items-center justify-end ltr:text-right rtl:text-left">
      <button *ngIf="!isLoadingContract" type="button" class="btn btn-outline-danger" (click)="close()">Cancel</button>
      <button *ngIf="!isLoadingContract" type="submit" (click)="submitForm()" class="btn btn-primary ltr:ml-4 rtl:mr-4">Submit</button>
      <button *ngIf="isLoadingContract" type="button" class="btn btn-primary ltr:ml-4 rtl:mr-4">
        <span class="inline-block h-5 w-5 animate-spin rounded-full border-2 border-white border-l-transparent align-middle ltr:mr-4 rtl:ml-4"></span>Loading
      </button>
    </div>
  </form>
</div>
